export default "__VITE_ASSET__928d1fe6__"